import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {AccountSearchModel} from "../account-search.model";
import {AccountSearchPageComponent} from "../account-search-page/account-search-page.component";
import {AccountEditPageComponent} from "../account-edit-page/account-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-account-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(AccountSingleSelectEditControlComponent),
        provideSearchModel(AccountSearchModel)
    ]
})
export class AccountSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<AccountSearchModel> {
    constructor(model: AccountSearchModel, injector: Injector) {
        super(model, injector, "accountId", "accountName");

        this.extendedSearchComponent = AccountSearchPageComponent;
        this.extendedEditComponent = AccountEditPageComponent;
    }
}
